export interface ProjectContextSource {
  type: string;
  title?: string;
  id?: string;
  detail?: string;
}

export interface ProjectContextGenerationResponse {
  context: string;
  sources: ProjectContextSource[];
  model: string;
  generatedAt: string;
}

export async function generateProjectContext(
  projectId: string,
  options: { force?: boolean } = {},
): Promise<ProjectContextGenerationResponse> {
  if (!projectId) {
    throw new Error("projectId is required");
  }

  const response = await fetch(`/api/projects/${encodeURIComponent(projectId)}/context/generate`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(options ?? {}),
  });

  const payload = (await response.json()) as ProjectContextGenerationResponse & { error?: string };

  if (!response.ok) {
    throw new Error(payload?.error ?? `Failed to generate project context (status ${response.status})`);
  }

  return payload;
}
